import { Dispatch, SetStateAction, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { alpha, Chip, ChipProps, Typography, useTheme } from '@mui/material';

import clsx from 'clsx';
import styled from 'styled-components';

import { ROIMetricDisplayType } from '@arrived/common';

import { ROIMetricDisplayText } from './ROIMetricDisplayType';

export interface ROIMetricDisplayToggleProps extends Omit<ChipProps, 'label' | 'onClick'> {
  displayType: ROIMetricDisplayType;
  setDisplayType: Dispatch<SetStateAction<ROIMetricDisplayType>>;
}

const StyledROIMetricDisplayToggle = styled(Chip)<{ $color: string }>`
  &.display-toggle {
    background-color: ${({ $color }) => alpha($color, 0.05)};
    padding: ${({ theme }) => theme.spacing(2.5, 2)};
    border-color: ${({ $color }) => $color};
    flex-direction: row-reverse;

    .MuiChip-label {
      padding: 0;
    }

    .down-arrow {
      color: ${({ $color }) => $color};
    }
  }
`;

export const ROIMetricDisplayToggle = ({
  className,
  displayType,
  setDisplayType,
  ...rest
}: ROIMetricDisplayToggleProps) => {
  const handleOnClick = useCallback(() => {
    setDisplayType((displayType) => (displayType + 1) % (Object.keys(ROIMetricDisplayType).length / 2));
  }, []);
  const theme = useTheme();

  const { color, formattedMessageProps } = useMemo(() => ROIMetricDisplayText[displayType], [displayType]);

  return (
    <StyledROIMetricDisplayToggle
      {...rest}
      $color={color(theme)}
      className={clsx('display-toggle', className)}
      icon={<KeyboardArrowDown className="down-arrow" />}
      label={
        <Typography color={color} variant="body1.medium">
          <FormattedMessage {...formattedMessageProps} />
        </Typography>
      }
      onClick={handleOnClick}
      variant="outlined"
    />
  );
};
